import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import './footer.css'
import logo from '../../assets/sharva.png'
// import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa'
import { FiMapPin, FiMail } from 'react-icons/fi'
import { BsTelephone } from 'react-icons/bs'
import instagram_img from '../../assets/instagram.webp'
import youtube from '../../assets/youtube.webp'
import facebook from '../../assets/facebook.webp'
const Footer = () => {
  return (
    <>
      <div className='footer my-5'>
        <footer>
          <Container>
            <Row>
              <Col md={3}>
                <div className='logo'>
                  <img src={logo} alt='' />
                </div>
                <div className='about mt-3'>
                  <p>We are a healthcare therapy provider focused on the diagnosis and treatment of disorders of the musculoskeletal.</p>
                </div>

                <div className='footer_social'>
                  <a href='https://www.facebook.com/sharvaclinique/'>
                    <img src={facebook} alt='social_media' className=' media-icon mt-2' style={{ width: '35px', height: '35px' }} />
                  </a>
                  <a href='https://www.youtube.com/@SharvaClinic'>
                    <img src={youtube} alt='social_media' className=' media-icon mt-2' style={{ width: '35px', height: '35px' }} />
                  </a>{' '}
                  <a href='https://www.instagram.com/sharvaclinic/'>
                    <img src={instagram_img} alt='social_media' className='media-icon mt-2' style={{ width: '35px', height: '35px' }} />
                  </a>{' '}
                </div>
              </Col>
              <Col md={3}>
                <div className='quick_link'>
                  <div className='head'>
                    <h5>Quick Links</h5>
                  </div>
                  <div className='links'>
                    <ul>
                      <a className='footerlink' href='/'>
                        <li>Home</li>
                      </a>
                      <a href='/about'>
                        <li>About</li>
                      </a>
                      <a href='/contact'>
                        <li>Contact</li>
                      </a>
                      <a href='/gallery'>
                        <li>Gallery</li>
                      </a>
                      <a href='/award'>
                        <li>Award</li>
                      </a>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col md={3}>
                <div className='quick_link'>
                  <div className='head'>
                    <h5>Support</h5>
                  </div>
                  <div className='links'>
                    <ul>
                      <a href='/privacy'>
                        <li>Privacy Policy</li>
                      </a>
                      <a href='/sitemap'>
                        <li>Sitemap</li>
                      </a>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col md={3}>
                <div className='quick_link'>
                  <div className='head'>
                    <h5>Our Clinic</h5>
                  </div>
                  <div className='links'>
                    <Row>
                      <Col md={2} xs={2}>
                        <FiMapPin className='soc_icon' />
                      </Col>
                      <Col md={10} xs={10}>
                        <ul>
                          <li> Plot 63, first floor, Harsh Vihar , Pitampura , New Delhi</li>
                        </ul>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={2} xs={2}>
                        <BsTelephone className='soc_icon' />
                      </Col>
                      <Col md={10} xs={10}>
                        <ul>
                          <li>
                            <a
                              href='tel:+917011470120'
                              onClick={() => {
                                if (window.gtag) {
                                  window.gtag('event', 'conversion', {
                                    send_to: 'AW-11422192869/j9f8CNnRxuUcEOWpw8Yq',
                                  })
                                }
                              }}
                            >
                              +91 7011470120
                            </a>
                          </li>
                          <li>
                            <a href='tel:+919711101138'>+91 9711101138</a>
                          </li>
                        </ul>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={2} xs={2}>
                        <FiMail className='soc_icon' />
                      </Col>
                      <Col md={10} xs={10}>
                        <ul>
                          <li>shharvaclnic@gmail.com</li>
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </>
  )
}

export default Footer
